var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShopListMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 17,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#shop-list-mobile_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.06 4.129c1.137 0 2.06-.925 2.06-2.065S3.196 0 2.06 0 0 .924 0 2.064.922 4.13 2.06 4.13M7.148 3.157h9.571a1.093 1.093 0 0 0 0-2.186H7.148a1.093 1.093 0 0 0 0 2.186M2.06 10.564c1.137 0 2.06-.924 2.06-2.064s-.923-2.064-2.06-2.064S0 7.36 0 8.5s.922 2.064 2.06 2.064M16.72 7.407H7.147a1.093 1.093 0 0 0 0 2.186h9.571a1.093 1.093 0 0 0 0-2.186M2.06 17c1.137 0 2.06-.924 2.06-2.064s-.923-2.065-2.06-2.065S0 13.797 0 14.936.922 17 2.06 17M16.72 13.843H7.147a1.093 1.093 0 0 0 0 2.186h9.571a1.093 1.093 0 0 0 0-2.186"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shop-list-mobile_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17.809v17H0z"
})))));
export { SvgShopListMobile as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvc2hvcC1saXN0LW1vYmlsZS41MmExMDAwYi5zdmciOw==";